import api from './api'

export function connectNotificationStream() {
  // Construct the full URL using api's base URL
  const streamUrl = `${api.defaults.baseURL}/notifications/stream?user_id=123`

  const eventSource = new EventSource(streamUrl)

  eventSource.addEventListener('notification', (event) => {
    const data = JSON.parse(event.data)
    console.log('🔔 Notification:', data)
  })

  eventSource.addEventListener('ping', () => {
    console.log('Ping received')
  })

  eventSource.onerror = () => {
    console.warn('SSE disconnected, retrying...')
  }

  return eventSource
}
